export const TEACHER_APP_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.montestory.parentapp";

export const PARENT_APP_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=srshta.montestoryparent";

export const TEACHER_APP_APP_STORE_URL = null;

export const PARENT_APP_APP_STORE_URL =
  "https://apps.apple.com/in/app/montestory-parent/id6772454260";

export const ANDROID_APP_OPTIONS = [
  { label: "Montestory Teacher", url: TEACHER_APP_PLAY_STORE_URL },
  { label: "Montestory Parent", url: PARENT_APP_PLAY_STORE_URL },
];

export const IOS_APP_OPTIONS = [
  ...(TEACHER_APP_APP_STORE_URL
    ? [{ label: "Montestory Teacher", url: TEACHER_APP_APP_STORE_URL }]
    : []),
  { label: "Montestory Parent", url: PARENT_APP_APP_STORE_URL },
];
